import { Component, input } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
	selector: 'app-accordion-section',
	standalone: true,
	imports: [CdkAccordionModule],
	templateUrl: './accordion-section.component.html',
	styleUrls: ['./accordion-section.component.scss'],
	animations: [
		trigger('bodyExpansion', [
			state('collapsed', style({ height: '0px', opacity: 0, visibility: 'hidden' })),
			state('expanded', style({ height: '*', opacity: 1, visibility: 'visible' })),
			transition('collapsed <=> expanded', [animate('250ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
		]),
	],
})
export class AccordionSectionComponent {
	title = input.required<string>();
	expanded = input<boolean>(true);
}
